export default __webpack_public_path__ + "static/media/kayaguneriplus4.dfd94f5e.jpg";